export const dictCaseEditComp = {
    TEXTAREA_ROWS : { minRows: 6, maxRows: 6 },
}
